import { useEffect, useMemo } from 'react';
import { DataFilter } from './DataFilter';
import { useInitializeFilter } from './hooks';
import {
  FiltersProvider,
  useFiltersCtxActions,
  useFiltersCtxStore
} from './store';
import { countChanges, hasChanges } from './utils';

const arr = [];

const FilterBare = ({
  filterConfig = arr,
  onSet = () => {},
  normalizeOnFilterChange,
  onListenChanges,
  arrowConfig = {},
  dataRole,
  classNames = {},
  enableFilterBtn = false
}) => {
  const {
    containerClassName = '',
    filterClassName = '',
    filterButtonClassName = '',
    controlWrapperClassName = '',
    applyBtnClassName = ''
  } = classNames;
  const currentFilterData = useFiltersCtxStore('currentFilterData');
  const appliedFilterData = useFiltersCtxStore('appliedFilterData');
  const initialFilterData = useMemo(
    () =>
      filterConfig.reduce(
        (obj, { key, options = [], defaultValue }) => ({
          ...obj,
          [key]: defaultValue || options[0]?.value
        }),
        {}
      ),
    [filterConfig]
  );

  const { SET_FILTER, COUNT_CHANGES, CHANGE_FILTER } = useFiltersCtxActions();

  useInitializeFilter({ filterConfig, initialFilterData });

  useEffect(() => {
    COUNT_CHANGES({
      changesCount: countChanges(currentFilterData, initialFilterData),
      isChanged:
        enableFilterBtn || hasChanges(currentFilterData, appliedFilterData)
    });
  }, [currentFilterData, enableFilterBtn]);

  const onChangeFilterData = (data) => {
    if (normalizeOnFilterChange) {
      // to mutate current filter's data from parent component need to return this
      // data from function where <Filter/> is used to update data in local store
      // there is an example in <CasinoHistory/> 99-th row function
      const changedData = normalizeOnFilterChange(data);
      CHANGE_FILTER(changedData);
    } else {
      CHANGE_FILTER(data);
    }
  };

  const handleSet = (data = {}) => {
    const bufChanges = { ...currentFilterData, ...data };

    if (onSet) {
      onSet(bufChanges);
    }
    return SET_FILTER(bufChanges);
  };

  useEffect(() => {
    if (onListenChanges) {
      onListenChanges(currentFilterData);
    }
  }, [currentFilterData, onListenChanges]);

  return (
    <DataFilter
      filterClassName={filterClassName}
      filterConfig={filterConfig}
      onChangeFilterData={onChangeFilterData}
      onSet={handleSet}
      containerClassName={containerClassName}
      arrowConfig={arrowConfig}
      filterButtonClassName={filterButtonClassName}
      applyBtnClassName={applyBtnClassName}
      controlWrapperClassName={controlWrapperClassName}
      dataRole={dataRole}
    />
  );
};

export const Filter = (props) => (
  <FiltersProvider>
    <FilterBare {...props} />
  </FiltersProvider>
);
